import { useRouter } from 'next/router';
import { useEffect } from 'react';

import {
  setEditingImageUrl,
  setEditingMaterialId,
  setShowEditImage,
  useAppDispatch,
} from '../state';

export function usePresetEditState() {
  const router = useRouter();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const { material_id, material_img_url } = router.query;
    if (material_id) {
      dispatch(setEditingMaterialId(Number(material_id)));
      dispatch(setShowEditImage(true));
    }
    if (material_img_url) {
      dispatch(setEditingImageUrl(material_img_url as string));
      dispatch(setShowEditImage(true));
    }
  }, [dispatch, router.query]);
}
